import GiftProductDetailContainer from './GiftProductDetailContainer';
export default GiftProductDetailContainer;
